<template>
  <div class="wrapper">
    <sidebar-v2 />
    <div id="content">
      <top-toolbar />
      <router-view />
      <timer-access-token2 :refreshTokenTime="60" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TimerAccessToken2 from "../components/TimerAccessToken2";
import VNavMenu from "../layouts/components/vertical-nav-menu/VerticalNavMenu";
import VSidebar from "../layouts/components/sidebar/vSidebar";
let Sidebar = require('./template/SiderBar').default;
let TopToolbar = require('./template/TopToolbar').default;
import sidebarV2 from './template/sidebar-v2/sidebar.vue'

export default {
  name: 'backoffice',
  components: {
    VSidebar,
    sidebarV2,
    VNavMenu,
    TimerAccessToken2,
    Sidebar,
    TopToolbar
  },
  data: () => ({
    menuVisible: true,
    toggleCard: false,
    buttonActive: true,
    latitude: 0,
    longitude: 0
  }),
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState(["loading"]),
    ...mapState("auth", ["geolocation"])
  },
  async created() {
    window.addEventListener('resize', this.handleWindowResize)
  },
  async mounted() {
    if (this.geolocation === null || this.user === null) {
      await this.checkGeolocation()
    }

    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    if (this.user === null) {
      this.menuVisible = false;
      this.buttonActive = false;
    } else {
      /*Echo.private('App.User.' + this.user.user_id)
        .notification((notification) => {
          console.log(notification.type);
        });*/
    }
  },
  methods: {
    ...mapActions("auth", ["checkGeolocation"]),
    setLastActivity(log) {

    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>
<style>
th div.vs-table-text {
  text-transform: uppercase;
}
</style>
<style scoped>
iframe {
  height: 400px !important;
}
</style>
<style>
.page-header-view table td {
  min-width: auto !important;
}
</style>
